module.exports = __webpack_public_path__ + "static/media/andronicos.124f4f52.svg";